export default {
  errorsRootKey: 'clients',
  resource: 'clients',
  actions: ['show']
}
